import FindPassword from './components/FindPassword';

const FindPasswordPage = () => {
  return (
    <div className="my-40 flex flex-col items-center justify-center">
      <FindPassword />
    </div>
  );
};

export default FindPasswordPage;
